import axios from 'axios';
import { TYPES_NOTIFICATIONS } from '../types/menu-notifications';
import { downloadExcel, downloadFile } from '../utils/files';
import { variables } from '../utils/variables';
import { admin_notifications, principal_notifications } from './routes';

/* admin notifications */
const getAllInspections = async (page: number = 0) =>
  await axios.get(
    `${admin_notifications.GET_INSPECTIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
  );

const getOneInspection = async (id: number) =>
  await axios.get(admin_notifications.GET_INSPECTION(id));

const downloadOneInspection = async (id: number, name: string) =>
  await axios
    .get(admin_notifications.DOWNLOAD_INSPECTION(id), { responseType: 'blob' })
    .then(({ data }) => downloadExcel(data, name));

const uploadInspectionsFile = async (name: string, file: File) => {
  const data = new FormData();
  data.append('name', name);
  data.append('file', file);

  return await axios.post(admin_notifications.UPLOAD_INSPECTION_FILE, data);
};

/* decisions */
const getAllDecisions = async (page: number = 0) =>
  await axios.get(
    `${admin_notifications.GET_DECISIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
  );

const downloadOneDecision = async (
  id: number,
  institutionId: number,
  name: string
) =>
  await axios
    .get(admin_notifications.DOWNLOAD_DECISION(id, institutionId), {
      responseType: 'blob'
    })
    .then(({ data }) => downloadFile(data, name));

const uploadDecision = async (
  name: string,
  file: File,
  institution: string
) => {
  const data = new FormData();
  data.append('name', name);
  data.append('institutionId', institution);
  data.append('file', file);

  return await axios.post(admin_notifications.UPLOAD_DECISION_FILE, data);
};

const uploadCurteConturiFile = async (name: string, file: File) => {
  const data = new FormData();
  data.append('name', name);
  data.append('File', file);

  return await axios.post(admin_notifications.UPLOAD_CURTECONTURI_FILE, data);
};

const getNotifications = async (
  category: string,
  page: number,
  search?: string
) => {
  return (
    await axios.get(
      `${principal_notifications.GET_NOTIFICATIONS(
        category
      )}/?search=${search}&PageNumber=${page}&PageSize=${
        variables.paginationRatio
      }`
    )
  ).data;
};
/* principal & secondary notifications */
const getPrincipalsNotifications = async (type: string, page: number = 0) => {
  switch (type) {
    case TYPES_NOTIFICATIONS.CONTROALE:
      return (
        await axios.get(
          `${principal_notifications.GET_INSPECTIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
        )
      ).data;
    case TYPES_NOTIFICATIONS.HOTARARI:
      return (
        await axios.get(
          `${principal_notifications.GET_DECISIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
        )
      ).data;
    // case TYPES_NOTIFICATIONS.ACTIUNI:
    //   return (
    //     await axios.get(
    //       `${principal_notifications.GET_ACTIONS_NOTIFICATIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
    //     )
    //   ).data;
    case TYPES_NOTIFICATIONS.MASURI:
      return (
        await axios.get(
          `${principal_notifications.GET_MEASURES_NOTIFICATIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
        )
      ).data;
    case TYPES_NOTIFICATIONS.DOCUMENTS:
      return (
        await axios.get(
          `${principal_notifications.GET_DOCS_NOTIFICATIONS}?PageNumber=${page}&PageSize=${variables.paginationRatio}`
        )
      ).data;
  }
};
export {
  getAllInspections,
  getOneInspection,
  downloadOneInspection,
  uploadInspectionsFile,
  getAllDecisions,
  downloadOneDecision,
  uploadDecision,
  getPrincipalsNotifications,
  uploadCurteConturiFile,
  getNotifications
};
